import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BaseComponent } from 'src/app/components/base-component';

@Component({
  selector: 'app-signer-error',
  templateUrl: './signer-error.component.html',
  styleUrls: ['./signer-error.component.scss']
})
export class SignerErrorComponent extends BaseComponent implements OnInit {


  signedId?: any;

  constructor(
    private router: Router
  ) {super();}

  ngOnInit() {
    
  }

}
